import React from "react";
import { connect } from "react-redux";
import styled, { keyframes } from "styled-components";
import { NextStepButton, Logo } from "components";
import { MOVE_TAB } from "actions";

const ani = keyframes`
0% {
  top: 84px;
  left: 84px;
  width: 0;
  height: 0;
  opacity: 1;
}
100% {
  top: -3px;
  left: -3px;
  width: 174px;
  height: 174px;
  opacity: 0;
}
`;

const Ripples = styled.div`
  position: relative;
  width: 171px;
  margin: 0 auto;
  height: 171px;
  div {
    position: absolute;
    border: 4px solid ${props => props.bg};
    opacity: 1;
    border-radius: 50%;
    animation: ${ani} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  div:nth-child(2) {
    animation-delay: -0.5s;
  }
`;

const RippleContainer = styled.div`
  width: 100%;
  p {
    text-align: center;
    line-height: 1.23;
    color: #191919;
    font-size: 26px;
    font-weight: bold;
    margin: 0 auto 50px;
    margin-top: 30px;
    max-width: 415px;
    @media (max-width: 640px) {
      font-size: 20px;
      text-align: left;
      line-height: 1.4;
    }
  }
`;

class Tab6 extends React.Component {
  state = {
    loadingDone: false
  };
  componentDidMount = () => {
    setTimeout(() => {
      this.setState({
        loadingDone: true
      });
    }, 5000);
  };
  render() {
    const { domain, pricingMonthly, pricingAnnually } = this.props;

    return (
      <div className="form_steps">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            {this.state.loadingDone ? (
              <div>
                <h2 className="link_checkbox_container--title">{domain.Strings.tab6Title}</h2>

                <Box>
                  <BoxTitle>{domain.Strings.tab6MonthlyLabel}</BoxTitle>
                  <BoxValue>£{pricingMonthly}</BoxValue>

                  <BoxTitle>{domain.Strings.tab6AnnualLabel}</BoxTitle>
                  <BoxValue>£{pricingAnnually}</BoxValue>

                  <BoxInfo>{domain.Strings.tab6Info}</BoxInfo>
                </Box>

                <NextStepButton text={domain.Strings.tab6NextBtn} onClick={this.props.moveToNextTab} />
              </div>
            ) : (
              <RippleContainer>
                <Ripples bg={domain.BaseColour}>
                  <div />
                  <div />
                </Ripples>
                <p>{domain.Strings.tab6LoadingTitle}</p>
              </RippleContainer>
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab6);

const Box = styled.div`
  border: 1px solid #ccc;
  text-align: center;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  width: 500px;
`;
const BoxTitle = styled.div`
  margin-bottom: 5px;
`;
const BoxValue = styled.div`
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 25px;
`;

const BoxInfo = styled.div`
  margin-top: 20px;
  font-weight: 200;
  line-height: 1.6;
`;
